import React from 'react';
import { Route } from 'react-router-dom';
import RoutesSignalerErreur from './signaler-erreur/routes';
import ArmeSignalerErreur from './signaler-erreur';
import RoutesSignalerArmeManquante from './signaler-arme-manquante/routes';
import SignalerArmeManquante from './signaler-arme-manquante';
import RoutesSignalerArmePerdueVolee from './signaler-perte-vol/routes';
import ArmePerdueVolee from './signaler-perte-vol';
import RoutesDemanderImpression from './demander-impression/routes';
import DemanderImpression from './demander-impression';
import ArmeCorrigerInformations from '../ratelier/armes/components/repriseDeDonnees/CorrigerArme';
import RoutesRepriseDonnees from '../ratelier/armes/components/repriseDeDonnees/CorrigerArme/routes';
import SupprimerArme from './supprimer';
import RoutesSupprimerArme from './supprimer/routes';
import {
    DROITS_SIGNALER_ARME_ERREUR,
    DROITS_SIGNALER_ARME_MANQUANTE,
} from '../../../utils/droitsEtRoles.constant';
import RouteSecurisee from '../../../components/RouteSecurisee/RouteSecurisee';
import DemandeArmeTrouvee from './demande-arme-trouvee';
import RoutesDemandeArmeTrouvee from './demande-arme-trouvee/routes';
import RoutesDemandeArmeHeritee from './demande-arme-heritee/routes';
import DemandeArmeHeritee from './demande-arme-heritee';
import { getPath } from '../../../utils/router';

const Armes = () => {
    return (
        <>
            <RouteSecurisee
                path={getPath(RoutesSignalerErreur)}
                render={(subProps) => <ArmeSignalerErreur {...subProps} />}
                droits={DROITS_SIGNALER_ARME_ERREUR}
            />
            <RouteSecurisee
                path={getPath(RoutesSignalerArmeManquante)}
                render={(subProps) => <SignalerArmeManquante {...subProps} />}
                droits={DROITS_SIGNALER_ARME_MANQUANTE}
            />
            <Route
                path={getPath(RoutesSignalerArmePerdueVolee)}
                render={(subProps) => <ArmePerdueVolee {...subProps} />}
            />
            <Route
                path={getPath(RoutesDemanderImpression)}
                render={(subProps) => <DemanderImpression {...subProps} />}
            />
            <Route
                path={getPath(RoutesRepriseDonnees)}
                render={(subProps) => <ArmeCorrigerInformations {...subProps} />}
            />
            <Route
                path={getPath(RoutesSupprimerArme)}
                render={(subProps) => <SupprimerArme {...subProps} />}
            />
            <Route
                path={getPath(RoutesDemandeArmeTrouvee)}
                render={(subProps) => <DemandeArmeTrouvee {...subProps} />}
            />
            <Route
                path={getPath(RoutesDemandeArmeHeritee)}
                render={(subProps) => <DemandeArmeHeritee {...subProps} />}
            />
        </>
    );
};

export default Armes;
